import { fieldset } from "@/ui/theme";
export default {
  fieldset,
};
